export default __webpack_public_path__ + "static/media/Procter-Gamble.2300fc41.jpg";